<template>
  <div class="app-container top-padding" uk-height-viewport="expand: true">
    <div class="uk-flex uk-flex-column uk-flex-center container">
      <div class="error-icon uk-width-1-1 uk-flex uk-flex-center">
        <img :src="errorIcon">
      </div>
      <div class="uk-text-center section-one">
        <h1>{{$t('brokenLink.heading')}}</h1>
        <p>{{$t('brokenLink.description1')}}</p>
      </div>
      <search-box></search-box>
      <div class="uk-text-center legacy-section">
        <h1>{{$t('brokenLink.option')}}</h1>
        <a class="legacy-link" @click="redirect(legacyUrl, selfTarget)">{{$t('brokenLink.continueLink')}}</a>
      </div>
      <div class="uk-text-center error-section">
        <h2>{{$t('brokenLink.errorCode')}}</h2>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchBox from '../navigation-bar/search-box'
  import * as staticUrl from '../../enums/static-urls'
  import * as routes from '../../enums/routes'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'

  export default {
    name: 'error-broken-link',
    components: {SearchBox},
    props: ['id'],
    data() {
      return {
        legacyUrl: `${staticUrl.LEGACY_EXCHANGE_DOMAIN + routes.LEGACY_PATHNAME_DETAILS}?id=${this.id}`,
        selfTarget: '_self',
        defaultTarget: '_blank',
        errorIcon: iconUtil.resolve(misc.ERROR_INFO_ICON)
      }
    },
    metaInfo() {
      return {
        meta: [
          { name: 'robots',
            content: 'noindex'
          }
        ]
      }
    },
    methods: {
      redirect(url, target) {
        window.open(url, target)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints';
  @import '../../styles/colours';

  .top-padding {
    padding-top: 86px;
  }

  .error-icon {
    padding-top: 164px;
    padding-bottom: 22px;
  }

  .section-one {
    color: $content-text;

    h1 {
      font-size: 41px;
      font-weight: bold;
      line-height: 1.41;
      margin: 0;
    }

    p {
      font-size: 33px;
      line-height: 1.59;
      margin-bottom: 41px;
    }
  }

  .legacy-section, h1 {
    color: $content-text;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.5;

    h1 {
      margin-top: -3px;
      margin-bottom: 5px;
    }

    .legacy-link {
      color: $content-link-blue;
    }
  }

  .error-section {
    h2 {
      padding-top: 47px;
      font-size: 24px;
      color: $content-text-light;
    }
  }

  .learn-more-link {
    color: $content-link-blue;
    font-weight: bold;
  }

  .container {
    padding: 0 7%;
  }

  @media screen and (max-width: $breakpoint-small) {
    .error-icon {
      padding-top: 144px;
    }
    .section-one {
      color: $content-text;

      h1 {
        font-size: 20px;
        padding-bottom: 20px;
      }

      p {
        font-size: 16px;
        margin-bottom: 0px;
      }
    }

    .legacy-section, h1 {
      font-size: 14px;

      h1 {
        margin-top: 0px;
        margin-bottom: 5px;
      }
    }

    .error-section {
      h2 {
        padding-top: 20px;
        font-size: 14px;
      }
    }
  }

  @media screen and (min-width: $breakpoint-small) and (max-width: $breakpoint-medium) {
    .app-container {
      width: 100%;
    }
    .error-icon {
      padding-top: 200px;
    }
    .top-padding {
      padding-top: 115px;
    }
    .section-one {
      color: $content-text;

      h1 {
        font-size: 38px;
      }

      p {
        font-size: 28px;
      }
    }
  }

  @media screen and (min-width: $breakpoint-medium) and (max-width: $breakpoint-large){
    .error-icon{
      padding-top: 110px;
    }
  }
</style>
